import { render } from "./EditJobVacancy.vue?vue&type=template&id=a7de05fa&scoped=true"
import script from "./EditJobVacancy.vue?vue&type=script&lang=js"
export * from "./EditJobVacancy.vue?vue&type=script&lang=js"

import "./vacancy.scss?vue&type=style&index=0&id=a7de05fa&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/gmX3YL_q/0/internal/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7de05fa"]])

export default __exports__